export default __webpack_public_path__ + "static/media/team-member-3.2d3ca639.png";